export default (store, { itemId }) => {
  store.dispatch('dataview/load', itemId);
};
